import ModalFrame from '@/components/common/ModalFrame';
import { ICON_CHECK_WHITE } from '@repo/assets';
import React from 'react';
import styled from 'styled-components';

type DepartureCertificationModalProps = {
  onClose: () => void;
};

function DepartureCertificationModal({
  onClose,
}: DepartureCertificationModalProps) {
  return (
    <ModalFrame
      title={
        <TitleWrapper>
          <img src={ICON_CHECK_WHITE} alt='' width={20} height={20} />
          <Title>출국 인증 완료</Title>
        </TitleWrapper>
      }
      content={
        <Content>
          <Description>
            출국 인증이 완료되었습니다.
            <br />
            출국 이후 14 영업일 이내 송금이 완료됩니다.
          </Description>
          <SubDescription>
            *송금 정보 수정이 필요할 경우 송금이 지연될 수 있습니다.
          </SubDescription>
        </Content>
      }
      buttons={<Button onClick={onClose}>확인</Button>}
    />
  );
}

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 16px;
`;
const Title = styled.strong`
  font-size: 16px;
  font-weight: 600;
  color: #030303;
`;

const Button = styled.button`
  width: 100%;
  height: 48px;
  border-radius: 8px;
  background-color: #246cf6;
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin-top: 16px;
`;

const Content = styled.div`
  display: flex;
  align-content: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  text-align: center;
`;

const Description = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #5f6165;
  line-height: 21px;
`;

const SubDescription = styled.p`
  font-size: 13px;
  font-weight: 400;
  color: #80848a;
  line-height: 19.5px;
`;

export default DepartureCertificationModal;
